var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-xs-12 m-t-20 m-b-30"},[_c('button',{staticClass:"btn btn-lg w-lg btn-success waves-effect waves-light ladda-button",attrs:{"id":"phone_button"},on:{"click":_vm.changePage}},[_c('span',{staticClass:"ladda-label"},[_vm._v("Exibir mais")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }